module.exports = __webpack_public_path__ + "img/right2.1abe7bea.png";